(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9060],{

/***/ 58401:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buy-back-telefoane",
      function () {
        return __webpack_require__(9058);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23043);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11752);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_3__["default"])(), settings = ref.publicRuntimeConfig.settings;
var SelectSearch = function(props) {
    var hasError = props.meta && props.meta.touched && props.meta.error;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            props.label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: props.id,
                className: "\n            Form-label\n            ".concat(props.labelClass && props.labelClass, "\n            ").concat(props.required ? "is-required" : "", "\n            ").concat(props.disabled ? "disabled" : "", "\n          "),
                children: typeof props.label === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: props.label
                    },
                    className: "inline-block"
                }) : props.label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "select-with-search w-full relative ".concat(props.containerClassName),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, _objectSpread({
                        components: {
                            IndicatorSeparator: function() {
                                return null;
                            },
                            Control: Control,
                            Option: Option,
                            Menu: Menu,
                            IndicatorsContainer: IndicatorsContainer
                        },
                        instanceId: props.id,
                        isDisabled: props.disabled,
                        isClearable: false,
                        hasError: hasError,
                        controlClassName: props.controlClassName,
                        menuPlacement: props.menuPlacement || "top",
                        maxMenuHeight: props.maxMenuHeight || 260,
                        menuShouldScrollIntoView: true,
                        menuClassName: props.menuClassName,
                        placeholder: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-black text-base font-normal leading-18.2",
                            children: props.placeholder
                        }),
                        options: props.options,
                        styles: {
                            valueContainer: function(rest) {
                                return _objectSpread({}, rest, props.valueContainerStyle);
                            }
                        }
                    }, props.input)),
                    props.loadingData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "ui dimmer inverted active",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "ui loader"
                        })
                    })
                ]
            }),
            hasError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-red-brand text-sm mt-2px",
                children: props.meta.error
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                children: "\n        .select-with-search .has-check:after {\n          content: url(".concat(settings.websiteStatics, "/images/check.svg);\n          display: inline-block;\n          float: right;\n        }\n      ")
            })
        ]
    }));
};
var colors = {
    selected: settings.websiteName === "altex" || settings.websiteName === "bricostore" ? "text-red-brand has-check" : "bg-secondary text-white"
};
var Menu = function(_param) {
    var children = _param.children, innerRef = _param.innerRef, innerProps = _param.innerProps, getStyles = _param.getStyles, selectProps = _param.selectProps, rest = _objectWithoutProperties(_param, [
        "children",
        "innerRef",
        "innerProps",
        "getStyles",
        "selectProps"
    ]);
    var menuClassName = selectProps.menuClassName;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({
        ref: innerRef
    }, innerProps, {
        style: _objectSpread({}, getStyles("menu", rest), {
            marginTop: "-1px",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
        }),
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_defineProperty({}, menuClassName, menuClassName)),
        children: children
    })));
};
var Control = function(param) {
    var children = param.children, innerRef = param.innerRef, innerProps = param.innerProps, isDisabled = param.isDisabled, isFocused = param.isFocused, selectProps = param.selectProps;
    var controlClassName = selectProps.controlClassName;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({
        ref: innerRef
    }, innerProps, {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_defineProperty({
            "flex rounded-bl-lg rounded-tr-lg justify-between border shadow-inner overflow-hidden": true,
            "border-gray-1100": !selectProps.hasError,
            "border-red-brand bg-red-bg": selectProps.hasError,
            "opacity-50": isDisabled,
            "rounded-b-none": selectProps.hasError || isFocused
        }, controlClassName, controlClassName)),
        style: {
            height: "44px",
            maxWidth: "390px",
            minWidth: "260px",
            background: "white"
        },
        children: children
    })));
};
var Option = function(_param) /*#__PURE__*/ {
    var children = _param.children, innerRef = _param.innerRef, innerProps = _param.innerProps, getStyles = _param.getStyles, isSelected = _param.isSelected, isFocused = _param.isFocused, rest = _objectWithoutProperties(_param, [
        "children",
        "innerRef",
        "innerProps",
        "getStyles",
        "isSelected",
        "isFocused"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({
        ref: innerRef
    }, innerProps, {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_defineProperty({
            "active:bg-newGray hover:bg-newGray": !isSelected,
            "bg-newGray": isFocused
        }, colors.selected, isSelected)),
        style: _objectSpread({}, getStyles("option", rest), {
            backgroundColor: null,
            color: null
        }),
        children: children
    }));
};
var IndicatorsContainer = function(_param) {
    var children = _param.children, innerRef = _param.innerRef, innerProps = _param.innerProps, getStyles = _param.getStyles, selectProps = _param.selectProps, rest = _objectWithoutProperties(_param, [
        "children",
        "innerRef",
        "innerProps",
        "getStyles",
        "selectProps"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({
        ref: innerRef
    }, innerProps, {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
            "rotate-180": selectProps.menuIsOpen
        }),
        style: _objectSpread({}, getStyles("indicatorsContainer", rest)),
        children: children
    })));
};
SelectSearch.defaultProps = {
    id: null,
    label: "",
    required: false,
    disabled: false,
    placeholder: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectSearch);


/***/ }),

/***/ 97995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var FullWidthSection = function(param) {
    var children = param.children, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "transparent" : _backgroundColor, _padding = param.padding, padding = _padding === void 0 ? "py-6" : _padding, _classProvided = param.classProvided, classProvided = _classProvided === void 0 ? "" : _classProvided, bgImmage = param.bgImmage;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative w-screen ".concat(backgroundColor, " ") + classProvided,
        style: {
            left: "50%",
            right: "50%",
            marginLeft: "-50vw",
            marginRight: "-50vw",
            backgroundImage: bgImmage !== undefined ? "url(".concat(bgImmage, ")") : "",
            backgroundRepeat: bgImmage !== undefined ? "no-repeat" : "",
            backgroundPosition: bgImmage !== undefined ? "right 3% bottom 7%" : "",
            backgroundSize: bgImmage !== undefined ? "160px 160px" : ""
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container ".concat(padding),
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FullWidthSection);


/***/ }),

/***/ 9058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ buy_back_telefoane; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
;// CONCATENATED MODULE: ./components/PhoneBuyBack/PhoneBuyBackHeader.js



var ref = (0,config["default"])(), settings = ref.publicRuntimeConfig.settings;
var PhoneBuyBackHeader = function(param) {
    var onBuyBackSimlationClick = param.onBuyBackSimlationClick;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "md:container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex mb-[35px] sm:gap-[40px] md:mb-0 lg:mx-auto lg:max-w-[90%]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "min-w-[60%]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-[#979797] italic font-medium sm:text-[24px] sm:mb-[10px] lg:mb-[20px]",
                                children: "Buy Back Telefoane"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[30px] font-bold leading-[34px] sm:text-[38px] sm:leading-[40px] lg:text-[56px] lg:leading-[60px] sm:mb-[20px] lg:mb-[40px]",
                                children: "Schimba telefonul pe care il ai cu cel pe care il doresti."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "hidden sm:block mb-[30px] text-[14px] lg:mb-[50px]",
                                children: "Iti ia doar cateva secunde sa afli cat poti primi pe vechiul tau telefon, apoi te asteptam in magazin pentru oferta finala"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden sm:block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    title: "Vezi estimare de buy back",
                                    variant: "secondary",
                                    size: "small",
                                    onClick: onBuyBackSimlationClick
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center overflow-y-clip",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "scale-[1.2] sm:scale-100 md:scale-[0.8] lg:scale-100 aspect-square ml-[20px] sm:ml-0",
                            src: "".concat(settings.websiteStatics, "/images/buy-back/buyBack_header.png"),
                            alt: ""
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "sm:hidden mb-[30px] text-[14px]",
                children: "Iti ia doar cateva secunde sa afli cat poti primi pe vechiul tau telefon, apoi te asteptam in magazin pentru oferta finala"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sm:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    title: "Vezi estimare de buy back",
                    variant: "secondary",
                    size: "small",
                    display: "block",
                    onClick: onBuyBackSimlationClick
                })
            })
        ]
    });
};
/* harmony default export */ var PhoneBuyBack_PhoneBuyBackHeader = (PhoneBuyBackHeader);

// EXTERNAL MODULE: ./components/Heading.js
var Heading = __webpack_require__(73510);
;// CONCATENATED MODULE: ./components/PhoneBuyBack/PhoneBuyBackSectionHeader.js

var PhoneBuyBackSectionHeader = function(param) {
    var title = param.title, children = param.children;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[24px] text-center font-semibold md:text-[32px]",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[14px] text-center max-w-[80%] m-auto",
                children: children
            })
        ]
    });
};
/* harmony default export */ var PhoneBuyBack_PhoneBuyBackSectionHeader = (PhoneBuyBackSectionHeader);

;// CONCATENATED MODULE: ./components/PhoneBuyBack/PhoneBuyBackSteps.js




var PhoneBuyBackSteps_ref = (0,config["default"])(), _publicRuntimeConfig = PhoneBuyBackSteps_ref.publicRuntimeConfig, websiteTitle = _publicRuntimeConfig.content.websiteTitle;
var steps = [
    {
        step: 1,
        title: "Vezi valoarea estimativa a vechiului tau telefon",
        content: "Cu ajutorul calculatorului nostru online, poți vedea cu usurinta cat valoreaza vechiul tau dispozitiv."
    },
    {
        step: 2,
        title: "Vino in magazin",
        content: "Pentru stabilirea valorii finale, vino cu telefonul \xeen cel mai apropiat magazin ".concat(websiteTitle, ".")
    },
    {
        step: 3,
        title: "Alege noul produs",
        content: "Cu voucher-ul primit poti achizitiona orice produs din magazin in termen de 7 zile."
    }, 
];
var PhoneBuyBackSteps = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-[60px] md:mb-[90px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneBuyBack_PhoneBuyBackSectionHeader, {
                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        as: "h2",
                        title: "Buy Back-ul pentru Telefoane nu a fost niciodata mai usor.",
                        font: "semibold",
                        classesProp: "mb-[15px]"
                    }),
                    children: "\xceti vom oferi o estimare a valorii vechiului tau dispozitiv, online sau in magazin."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "space-y-[60px] md:space-y-0 md:flex md:gap-[20px]",
                children: steps.map(function(param) {
                    var step = param.step, content = param.content, title = param.title;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                        className: "text-center border border-black rounded-[10px] relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "py-[45px] px-[40px] md:flex md:flex-col md:justify-between md:h-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[22px] font-semibold mb-[10px]",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[14px]",
                                        children: content
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute -top-[30px] left-0 right-0 w-[60px] h-[60px] leading-[60px] m-auto text-[32px] text-white bg-black rounded-full",
                                children: step
                            })
                        ]
                    }, step);
                })
            })
        ]
    }));
};
/* harmony default export */ var PhoneBuyBack_PhoneBuyBackSteps = (PhoneBuyBackSteps);

// EXTERNAL MODULE: ./components/FullWidthSection.js
var FullWidthSection = __webpack_require__(97995);
// EXTERNAL MODULE: ./store/app/actions.js
var actions = __webpack_require__(27173);
// EXTERNAL MODULE: ./lib/api/index.js
var api = __webpack_require__(2642);
// EXTERNAL MODULE: ./containers/ModalErrorBoundary.js
var ModalErrorBoundary = __webpack_require__(33849);
// EXTERNAL MODULE: ./components/Modal.js
var Modal = __webpack_require__(12280);
// EXTERNAL MODULE: ./components/Form/SelectSearch.js
var SelectSearch = __webpack_require__(9592);
;// CONCATENATED MODULE: ./components/PhoneBuyBack/PhoneBuyBackSimulationQuestions.js


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var PhoneBuyBackSimulationQuestions = function(param) {
    var questions = param.questions, onQuestionAnswer = param.onQuestionAnswer;
    var questionRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        if (questionRef === null || questionRef === void 0 ? void 0 : questionRef.current) {
            questionRef.current.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, [
        questions
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: questions.map(function(question) {
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                ref: questionRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[14px] font-medium mb-[10px]",
                        children: question === null || question === void 0 ? void 0 : question.question_text
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-[10px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: function() {
                                    return onQuestionAnswer({
                                        question: _objectSpread({}, question, {
                                            answer: question.options[0].option,
                                            grade: question.options[0].grade.toUpperCase()
                                        })
                                    });
                                },
                                className: "border border-[#ccc] hover:border-[#F5CB38] ".concat(question.answer === question.options[0].option ? "border-[#F5CB38]" : "", " w-full py-[12px] rounded-bl-[4px]"),
                                children: question.options[0].option
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: function() {
                                    return onQuestionAnswer({
                                        question: _objectSpread({}, question, {
                                            answer: question.options[1].option,
                                            grade: question.options[1].grade.toUpperCase()
                                        })
                                    });
                                },
                                className: "border border-[#ccc] hover:border-[#F5CB38] ".concat(question.answer === question.options[1].option ? "border-[#F5CB38]" : "", " w-full py-[12px] rounded-tr-[4px]"),
                                children: question.options[1].option
                            })
                        ]
                    })
                ]
            }, question.question_id);
        })
    }));
};
/* harmony default export */ var PhoneBuyBack_PhoneBuyBackSimulationQuestions = (PhoneBuyBackSimulationQuestions);

// EXTERNAL MODULE: ./components/Form/Select.js
var Select = __webpack_require__(66569);
;// CONCATENATED MODULE: ./components/PhoneBuyBack/PhoneBuyBackSimulation.js








function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function PhoneBuyBackSimulation_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function PhoneBuyBackSimulation_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PhoneBuyBackSimulation_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var PhoneBuyBackSimulation = function(param1) {
    var devices = param1.devices, flowChart = param1.flowChart, removeModal1 = param1.removeModal;
    var ref4;
    var firstQuestion = flowChart[0];
    var ref1 = (0,react.useState)({
        make: null,
        model: null,
        memory: ""
    }), selection = ref1[0], setSelection = ref1[1];
    var ref2 = (0,react.useState)(), deviceGrade = ref2[0], setDeviceGrade = ref2[1];
    var ref3 = (0,react.useState)([
        firstQuestion
    ]), questions = ref3[0], setQuestions = ref3[1];
    var phoneBrands = (0,react.useMemo)(function() {
        return Object.keys(devices).sort();
    }, [
        devices
    ]);
    var phoneModelsInBrand = (0,react.useMemo)(function() {
        return selection.make && Object.keys(devices[selection.make]).sort();
    }, [
        selection.make,
        devices
    ]);
    var hasMemoryOptions = (0,react.useMemo)(function() {
        var ref;
        return selection.make && selection.model && ((ref = Object.keys(devices[selection.make][selection.model])) === null || ref === void 0 ? void 0 : ref[0].length) > 0;
    }, [
        selection.make,
        selection.model,
        devices
    ]);
    var phoneMemoryOptions = (0,react.useMemo)(function() {
        return hasMemoryOptions && Object.keys(devices[selection.make][selection.model]);
    }, [
        selection.model,
        selection.make,
        devices,
        hasMemoryOptions
    ]);
    var showQuestions = hasMemoryOptions ? selection.make && selection.model && selection.memory : selection.make && selection.model;
    var showDeviceValueInfo = deviceGrade && deviceGrade === "D" || ((ref4 = questions[flowChart.length - 1]) === null || ref4 === void 0 ? void 0 : ref4.answer);
    var handleQuestionAnswer = function(param) {
        var question = param.question;
        if (!question) {
            return;
        }
        var grade = question.grade, question_id = question.question_id;
        var currentQuestionIndex = questions.findIndex(function(q) {
            return q.question_id === question_id;
        });
        if (currentQuestionIndex === -1) {
            return;
        }
        var newQuestions = _toConsumableArray(questions);
        newQuestions[currentQuestionIndex] = question;
        if (grade === "D") {
            setDeviceGrade(grade);
            if (currentQuestionIndex < newQuestions.length - 1) {
                setQuestions(newQuestions.slice(0, currentQuestionIndex + 1));
            } else {
                setQuestions(newQuestions);
            }
        } else {
            var nextQuestionIndex = currentQuestionIndex + 1;
            if (nextQuestionIndex <= flowChart.length - 1) {
                if (questions[nextQuestionIndex]) {
                    newQuestions[nextQuestionIndex] = flowChart[nextQuestionIndex];
                    setQuestions(newQuestions.slice(0, nextQuestionIndex + 1));
                    setDeviceGrade(grade);
                } else {
                    var nextQuestion = flowChart[nextQuestionIndex];
                    setQuestions(_toConsumableArray(newQuestions).concat([
                        nextQuestion
                    ]));
                    setDeviceGrade(grade);
                }
            } else {
                setQuestions(newQuestions);
                setDeviceGrade(grade);
            }
        }
    };
    var updateSelection = function(updates) {
        setSelection(function(prev) {
            return PhoneBuyBackSimulation_objectSpread({}, prev, updates);
        });
        if (deviceGrade) {
            setDeviceGrade(null);
        }
        if (questions && questions[0].answer) {
            setQuestions([
                firstQuestion
            ]);
        }
    };
    var handleMakeChange = function(param) {
        var value = param.value;
        updateSelection({
            make: value,
            model: null,
            memory: ""
        });
    };
    var handleModelChange = function(param) {
        var value = param.value;
        updateSelection({
            model: value,
            memory: ""
        });
    };
    var handleMemoryChange = function(param) {
        var value = param.value;
        updateSelection({
            memory: value
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "md:max-w-[75%] md:m-auto overflow-x-hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[24px] pb-[15px]",
                children: "Descopera valoarea estimata a dispozitivului tau"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[14px] pb-[25px]",
                children: "Cu Altex Buy Back Program, este usor sa-ti schimbi dispozitivul eligibil in schimbul unui credit sau sa il reciclezi gratuit."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-[15px] pt-[40px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectSearch/* default */.Z, {
                        input: {
                            onChange: handleMakeChange,
                            value: selection.make ? {
                                value: selection.make,
                                label: selection.make
                            } : ""
                        },
                        placeholder: "Selecteaza marca",
                        maxMenuHeight: 150,
                        options: phoneBrands.map(function(brand) {
                            return {
                                value: brand,
                                label: brand
                            };
                        })
                    }),
                    selection.make && /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectSearch/* default */.Z, {
                        input: {
                            onChange: handleModelChange,
                            value: selection.model ? {
                                value: selection.model,
                                label: selection.model
                            } : ""
                        },
                        placeholder: "Selecteaza modelul",
                        maxMenuHeight: 150,
                        options: phoneModelsInBrand && phoneModelsInBrand.map(function(model) {
                            return {
                                value: model,
                                label: model
                            };
                        })
                    }),
                    selection.make && selection.model && hasMemoryOptions && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
                        input: {
                            onChange: function(event) {
                                return handleMemoryChange({
                                    value: event.target.value
                                });
                            },
                            value: selection.memory ? selection.memory : ""
                        },
                        meta: {},
                        placeholder: "Selecteaza memoria",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: "",
                                children: "Selecteaza memoria"
                            }),
                            phoneMemoryOptions.map(function(memory) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                    value: memory,
                                    children: memory
                                }, memory);
                            })
                        ]
                    })
                ]
            }),
            showQuestions && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "py-[30px] space-y-[25px] border-t border-[#D9D9D9] mt-[40px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneBuyBack_PhoneBuyBackSimulationQuestions, {
                            questions: questions,
                            onQuestionAnswer: handleQuestionAnswer
                        })
                    }),
                    showDeviceValueInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center pt-[24px] border-t border-[#D9D9D9]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-[22px] text-red-brand font-semibold",
                                children: [
                                    "Poti primi pana la",
                                    " ",
                                    devices[selection.make][selection.model][selection.memory].grades[deviceGrade],
                                    " ",
                                    "lei"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[14px] text-center mt-[12px]",
                                children: "Pentru a stabili valoarea finală, te așteptăm \xeen magazin, unde un reprezentant va inspecta și evalua dispozitivul tău."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-[20px] sm:max-w-fit",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "secondary",
                                    title: "Inchide",
                                    display: "block",
                                    onClick: function() {
                                        return removeModal1("buy-back-simulation-modal");
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var PhoneBuyBack_PhoneBuyBackSimulation = ((0,es/* connect */.$j)(null, {
    removeModal: actions/* removeModal */.a_,
    addAlert: actions/* addAlert */.V_
})(PhoneBuyBackSimulation));

// EXTERNAL MODULE: ./containers/ErrorPage.js
var ErrorPage = __webpack_require__(75720);
// EXTERNAL MODULE: ./lib/api/helpers.js
var helpers = __webpack_require__(45963);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
;// CONCATENATED MODULE: ./components/PhoneBuyBack/PhoneBuyBackInfo.js




var PhoneBuyBackInfo_ref = (0,config["default"])(), PhoneBuyBackInfo_publicRuntimeConfig = PhoneBuyBackInfo_ref.publicRuntimeConfig, PhoneBuyBackInfo_websiteTitle = PhoneBuyBackInfo_publicRuntimeConfig.content.websiteTitle;
var PhoneBuyBackInfo = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                classesProp: "text-[22px] text-center mb-[24px]",
                display: "h3",
                as: "h3",
                title: "Buy Back Telefoane - Afla cat costa telefonul tau",
                font: "semibold"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white border border-black rounded-[12px] p-[20px] md:p-[30px] space-y-[18px] text-[14px] leading-[1.7] text-[#333333]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "font-semibold italic",
                        children: "Buy Back pentru Telefoane - schimba-ti telefonul vechi simplu, rapid si sigur!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Vrei sa iti schimbi telefonul vechi cu unul nou? Cu Programul Buy Back pentru Telefoane procesul este mai simplu ca niciodata."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Nu mai trebuie sa te complici cu estimari nesigure sau discutii lungi. Evaluarea telefonului tau este la doar cateva click-uri distanta. Fie ca ai un iPhone, Samsung, Huawei sau alt model de telefon, cu Buy Back pentru Telefoane de pe site-ul nostru te bucuri de cea mai buna oferta!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "font-semibold",
                        children: "Cum functioneaza programul de Buy-Back?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "list-disc pl-[18px] space-y-[6px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Calculeaza online – Introdu modelul telefonului si detaliile cerute pentru a afla o valoare estimativa."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    "Mergi in magazin – Pentru stabilirea valorii reale, vino cu telefonul in cel mai apropiat magazin ",
                                    PhoneBuyBackInfo_websiteTitle,
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Evaluare finala –Telefonul este verificat \xeen magazin sau, dupa procedura magazinului, trimis la furnizor pentru confirmarea valorii finale"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Alege noul produs – Cu voucher-ul primit poti achizitiona orice produs din magazin in termen de 7 zile"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "font-semibold",
                        children: [
                            "Nu mai astepta! Beneficiaza acum de Buy Back si ia-ti telefonul pe care ti-l doresti! Descopera gama noastra variata de",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: "/telefoane/cpl/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "text-red-brand underline hover:text-bleu-hover",
                                    children: "telefoane"
                                })
                            }),
                            " ",
                            "la cel mai mic pret din Romania!"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PhoneBuyBack_PhoneBuyBackInfo = (PhoneBuyBackInfo);

;// CONCATENATED MODULE: ./components/PhoneBuyBack/PhoneBuyBackQA.js


var FAQ_ITEMS = [
    {
        question: "Estimarea de pe site este pretul final?",
        answer: "Nu. Este orientativa. Pretul final se stabileste dupa evaluarea telefonului in magazin sau, dupa caz, de catre furnizor."
    },
    {
        question: "Pot trimite telefonul prin curier?",
        answer: "Nu. Buyback-ul se face doar in magazine, unde telefonul este evaluat direct sau trimis la furnizor."
    },
    {
        question: "Este obligatoriu sa cumpar un telefon nou?",
        answer: "Nu, primesti un cupon in valoarea telefonului predat, utilizabil pentru o achizitie de aceeasi valoare sau mai mare, direct in magazin. Termenul de utilizare a voucher-ului e de 7 zile."
    },
    {
        question: "Ce se intampla cu accesoriile si cutia?",
        answer: "Trebuie sa aduci doar telefonul, fara accesorii sau cutie. Pe acestea nu primesti contravaloare – fie le pastrezi si le folosesti tu, fie le reciclam noi."
    },
    {
        question: "Ce se intampla cu datele mele de pe telefonul pe care il dau la buyback?",
        answer: "Toate informatiile de pe telefon vor fi sterse complet. Iti recomandam sa faci un back-up inainte de a-l aduce in magazin."
    }, 
];
var PhoneBuyBackQA = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                classesProp: "text-[22px] mb-[24px] text-center",
                display: "h4",
                as: "h4",
                title: "Intrebari frecvente",
                font: "semibold"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white border border-black rounded-[12px] p-[20px] md:p-[30px] space-y-[18px] text-[14px] leading-[1.7] text-[#333333]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "list-disc pl-[18px] space-y-[10px]",
                    children: FAQ_ITEMS.map(function(param, index) {
                        var question = param.question, answer = param.answer;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-semibold",
                                    children: question
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                answer
                            ]
                        }, index);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var PhoneBuyBack_PhoneBuyBackQA = (PhoneBuyBackQA);

// EXTERNAL MODULE: ./components/Loading.js
var Loading = __webpack_require__(24461);
;// CONCATENATED MODULE: ./pages/buy-back-telefoane.js




















function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var buy_back_telefoane_ref = (0,config["default"])(), buy_back_telefoane_publicRuntimeConfig = buy_back_telefoane_ref.publicRuntimeConfig, _content = buy_back_telefoane_publicRuntimeConfig.content, buy_back_telefoane_websiteTitle = _content.websiteTitle, websiteUrlTitle = _content.websiteUrlTitle, websiteName = buy_back_telefoane_publicRuntimeConfig.settings.websiteName;
var PhoneBuyBack = function(param) {
    var addModal1 = param.addModal, addAlert1 = param.addAlert;
    var ref3 = (0,react.useState)(true), isLoading = ref3[0], setIsLoading = ref3[1];
    var ref1 = (0,react.useState)(), devices = ref1[0], setDeviceList = ref1[1];
    var ref2 = (0,react.useState)(), flowChart = ref2[0], setFlowChart = ref2[1];
    var startPhoneBuyBackSimulation = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var response1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        addModal1("buy-back-simulation-modal");
                        if (!isLoading && !(devices || flowChart)) {
                            setIsLoading(true);
                        }
                        if (devices || flowChart) {
                            _ctx.next = 7;
                            break;
                        }
                        _ctx.next = 5;
                        return (0,helpers/* makeApiCall */.Vo)({
                            apiCall: api/* getBuyBackDevicesApi */.azO,
                            formatResponse: function(response) {
                                var groupedDevices = response.data.devices.reduce(function(acc, device) {
                                    var make = device.make, model = device.model, memory = device.memory, offers = device.offers;
                                    if (acc[make]) {
                                        if (acc[make][model]) {
                                            if (acc[make][model][memory]) {
                                                acc[make][model][memory] = offers[0];
                                            }
                                            acc[make][model][memory] = offers[0];
                                        } else {
                                            acc[make][model] = {};
                                            acc[make][model][memory] = offers[0];
                                        }
                                    } else {
                                        acc[make] = {};
                                        acc[make][model] = {};
                                        acc[make][model][memory] = offers[0];
                                    }
                                    return acc;
                                }, {});
                                return {
                                    devices: groupedDevices,
                                    questions: response.data.questions
                                };
                            },
                            preFail: function() {
                                return addAlert1({
                                    message: "Ne pare rau. A aparut o eroare. Te rugam sa incerci mai tarziu.",
                                    variant: "error"
                                });
                            }
                        });
                    case 5:
                        response1 = _ctx.sent;
                        if (response1) {
                            setDeviceList(response1.devices);
                            setFlowChart(response1.questions);
                        }
                    case 7:
                        if (isLoading) {
                            setIsLoading(false);
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function startPhoneBuyBackSimulation() {
            return _ref.apply(this, arguments);
        };
    }();
    if (websiteName === "bricostore") {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* default */.Z, {
            layout: "404"
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            "Buy Back Telefoane | Cel mai mic pret din Romania | ",
                            buy_back_telefoane_websiteTitle
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Buy Back Telefoane ➤ Descopera valoarea telefonului tau pe ".concat(websiteUrlTitle, " ➤ Cel mai mic pret din Romania ⭐ ").concat(buy_back_telefoane_websiteTitle)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "index, follow"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://".concat(websiteUrlTitle, "/buy-back-telefoane/")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSection/* default */.Z, {
                classProvided: "bg-gradient-to-t from-[#CFE8F5] to-white px-[15px] py-[30px] overflow-hidden md:px-0 mb-[45px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneBuyBack_PhoneBuyBackHeader, {
                    onBuyBackSimlationClick: startPhoneBuyBackSimulation
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-[60px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneBuyBack_PhoneBuyBackSteps, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneBuyBack_PhoneBuyBackInfo, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneBuyBack_PhoneBuyBackQA, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto mt-[30px] md:max-w-fit",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    title: "Vezi estimare de buy back",
                    variant: "secondary",
                    size: "small",
                    display: "block",
                    onClick: startPhoneBuyBackSimulation
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalErrorBoundary/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal["default"], {
                    id: "buy-back-simulation-modal",
                    headerHasBorder: false,
                    children: [
                        isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
                            height: 100
                        }),
                        !isLoading && !(flowChart || devices) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "py-[50px] text-center",
                            children: "Ne pare rau. A aparut o eroare. Te rugam sa incerci mai tarziu."
                        }),
                        !isLoading && flowChart && devices && /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneBuyBack_PhoneBuyBackSimulation, {
                            devices: devices,
                            flowChart: flowChart
                        })
                    ]
                })
            })
        ]
    }));
};
PhoneBuyBack.pageLayout = "default";
/* harmony default export */ var buy_back_telefoane = ((0,es/* connect */.$j)(null, {
    addModal: actions/* addModal */.Y_,
    addAlert: actions/* addAlert */.V_
})(PhoneBuyBack));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3043,9774,2888,179], function() { return __webpack_exec__(58401); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);